import dynamic from 'next/dynamic';
import { PaymentInfoProps } from './PaymentInfo.types';

export const PaymentInfo = dynamic<{ model: PaymentInfoProps }>(() =>
  import('./PaymentInfo').then(mod => mod.PaymentInfo)
);
